import { defineComponent as _defineComponent } from 'vue'
import { Beneficiary } from 'ah-api-gateways';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeTransactionBankInfo',
  props: {
    beneficiary: null
  },
  setup(__props: any) {



return { __sfc: true,countryNameFromCC }
}

})